import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { combineReducers } from 'redux-immutable';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { ProgressCircular } from '@americanexpress/dls-react';
import { composeModules } from 'holocron';
import SharedScript from '@americanexpress/shared-scripts';
import childRoutes from '../../childRoutes';
import '../assets/dashboard.scss';
import { VrpDashboardProvider } from '../providers/VrpDashboardProvider';
import ContentWrapper from './VrpDashboard/ContentWrapper';
import dashboardReducer from '../ducks/dashboardApi';

const PwbDashboard = ({
  languageData,
  locale,
  children,
}) => {
  if (Object.entries(languageData).length === 0) {
    return (
      <div className="loading-container">
        <ProgressCircular label="Loading" />
      </div>
    );
  }

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <Helmet
        title="Pay with Bank Transfer | American Express"
        htmlAttributes={{ lang: locale }}
        link={[
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.15.0/stylesheets/dls-core.min.css',
          },
          { rel: 'icon', href: 'https://www.americanexpress.com/favicon.ico' },
        ]}
      />
      <SharedScript
        name="one-identity-session"
        version="^1.0.0"
        windowCheck="AmexSession"
      />
      <VrpDashboardProvider>
        <ContentWrapper>{children}</ContentWrapper>
      </VrpDashboardProvider>
    </IntlProvider>
  );
};

export const TestablePwbDashboard = PwbDashboard;

PwbDashboard.propTypes = {
  languageData: PropTypes.shape({}).isRequired,
  locale: PropTypes.string.isRequired,
  children: PropTypes.node,
};

PwbDashboard.childRoutes = childRoutes;

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require -- require needs to be inside browser check
  PwbDashboard.appConfig = require('../../appConfig').default;
}

export const loadModuleData = async ({ store: { dispatch } }) => {
  await Promise.all([
    dispatch(loadLanguagePack('axp-bank-permissions-dashboard-root', { fallbackLocale: 'en-US' })),
    dispatch(composeModules([{ name: 'axp-global-header' }, { name: 'axp-footer' }, { name: 'axp-page-wrapper' }])),
  ]);
};

PwbDashboard.holocron = {
  name: 'axp-bank-permissions-dashboard-root',
  reducer: combineReducers({ dashboard: dashboardReducer }),
  loadModuleData,
};

export default oneAppModuleWrapper('axp-bank-permissions-dashboard-root')(PwbDashboard);
